import dayjs from 'dayjs';
import fixDateTimezone from './fixDateTimezone';

// ÐÐ°Ð¿Ð¸ÑÐ¸ Ð¶Ð¸Ð²ÑÑ Ð²Ð¾ Ð²ÑÐµÐ¼ÐµÐ½Ð¸ Ð´Ð¸Ð»ÐµÑÐ° (Asia/Almaty): Ð±ÑÐºÐµÐ½Ð´ Ð¿ÑÐ¸Ð½Ð¸Ð¼Ð°ÐµÑ Ð½Ð°Ð¸Ð²Ð½ÑÑ
// ÑÑÑÐ¾ÐºÑ Ð±ÐµÐ· ÑÐ¼ÐµÑÐµÐ½Ð¸Ñ Ð¸ ÑÑÐ°ÐºÑÑÐµÑ ÐµÑ ÐºÐ°Ðº Ð°Ð»Ð¼Ð°ÑÐ¸Ð½ÑÐºÑÑ, Ð° ÑÐ¿Ð¸ÑÐºÐ¸ CRM ÑÐµÐ¼ Ð¶Ðµ
// Ð¿Ð¾ÑÑÐ¾Ð¼ ÐµÑ Ð¸ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÑÑ.
//
// ÐÐ°ÑÑÐ¾ÑÐºÐ° Ð·Ð°Ð¿Ð¸ÑÐ¸ ÑÐ°Ð½ÑÑÐµ ÑÑÐ¸ÑÐ°Ð»Ð° Ð´Ð°ÑÑ Ð² Ð¿Ð¾ÑÑÐµ Ð±ÑÐ°ÑÐ·ÐµÑÐ°. ÐÐµÐ½ÐµÐ´Ð¶ÐµÑ Ð·Ð°Ð¿Ð°Ð´Ð½ÐµÐµ
// ÐÐ»Ð¼Ð°ÑÑ Ð²Ð¸Ð´ÐµÐ» Ð½Ðµ ÑÐ¾ Ð²ÑÐµÐ¼Ñ (Ð·Ð°Ð¿Ð¸ÑÑ 05:30 Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»Ð°ÑÑ ÐºÐ°Ðº 01:30), Ð° ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ðµ
// ÑÐ¾Ð±Ð¸ÑÐ°ÐµÑ Ð´Ð°ÑÑ Ð¸Ð· Ð¿Ð¾ÐºÐ°Ð·Ð°Ð½Ð½Ð¾Ð³Ð¾ â Ð¿Ð¾ÑÑÐ¾Ð¼Ñ Ð¾Ð±ÑÑÐ½Ð¾Ðµ Â«Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑÂ», Ð±ÐµÐ· ÐµÐ´Ð¸Ð½Ð¾Ð¹
// Ð¿ÑÐ°Ð²ÐºÐ¸, ÑÐ´Ð²Ð¸Ð³Ð°Ð»Ð¾ Ð·Ð°Ð¿Ð¸ÑÑ Ð½Ð° ÑÐ°Ð·Ð½Ð¸ÑÑ Ð¿Ð¾ÑÑÐ¾Ð². ÐÐ°Ð¶Ð´ÑÐ¹ ÑÐ°Ð· ÐµÑÑ ÑÐ°Ð·.
//
// ÐÑÐµ ÑÑÐ¸ ÑÑÐ½ÐºÑÐ¸Ð¸ Ð´Ð°ÑÑ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²ÑÐ¹ ÑÐµÐ·ÑÐ»ÑÑÐ°Ñ Ð² Ð»ÑÐ±Ð¾Ð¼ Ð¿Ð¾ÑÑÐµ Ð±ÑÐ°ÑÐ·ÐµÑÐ°.

/** ÐÑÐµÐ¼Ñ Ð·Ð°Ð¿Ð¸ÑÐ¸ Â«HH:mmÂ» Ð²Ð¾ Ð²ÑÐµÐ¼ÐµÐ½Ð¸ Ð´Ð¸Ð»ÐµÑÐ°. */
export const timeOfRecord = (date) => (date ? fixDateTimezone(date).format('HH:mm') : '');

/**
 * ÐÐ½Ð°ÑÐµÐ½Ð¸Ðµ Ð´Ð»Ñ Ð´Ð°ÑÐ°Ð¿Ð¸ÐºÐµÑÐ°: Ð¿Ð¾Ð»Ð½Ð¾ÑÑ Ð¿Ð¾ Ð»Ð¾ÐºÐ°Ð»Ð¸ Ð±ÑÐ°ÑÐ·ÐµÑÐ° Ð½Ð° ÑÐ¾Ñ ÐºÐ°Ð»ÐµÐ½Ð´Ð°ÑÐ½ÑÐ¹ Ð´ÐµÐ½Ñ,
 * ÐºÐ¾ÑÐ¾ÑÑÐ¹ Ñ Ð·Ð°Ð¿Ð¸ÑÐ¸ Ð² ÐÐ»Ð¼Ð°ÑÑ.
 *
 * ÐÐ¼ÐµÐ½Ð½Ð¾ Ð´ÐµÐ½Ñ, Ð° Ð½Ðµ Ð¸ÑÑÐ¾Ð´Ð½ÑÐ¹ Ð¼Ð¾Ð¼ÐµÐ½Ñ: Ð·Ð°Ð¿Ð¸ÑÑ Ð¿Ð¾Ð´ Ð¿Ð¾Ð»Ð½Ð¾ÑÑ Ñ ÑÐ¾Ð³Ð¾, ÐºÑÐ¾ Ð·Ð°Ð¿Ð°Ð´Ð½ÐµÐµ,
 * Ð¸Ð½Ð°ÑÐµ Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°Ð»Ð°ÑÑ Ð±Ñ Ð¿ÑÐµÐ´ÑÐ´ÑÑÐ¸Ð¼ ÑÐ¸ÑÐ»Ð¾Ð¼ â Ð¸ ÑÐ°ÐºÐ¸Ð¼ Ð¶Ðµ ÑÐµÐ·Ð¶Ð°Ð»Ð° Ð¿ÑÐ¸ ÑÐ¾ÑÑÐ°Ð½ÐµÐ½Ð¸Ð¸.
 */
export const datePickerValue = (date) => {
  if (!date) return undefined;
  const almaty = fixDateTimezone(date);
  return new Date(almaty.year(), almaty.month(), almaty.date());
};

/**
 * ÐÐµÐ½Ñ Â«YYYY-MM-DDÂ» Ð´Ð»Ñ Ð¾ÑÐ¿ÑÐ°Ð²ÐºÐ¸ Ð½Ð° Ð±ÑÐºÐµÐ½Ð´.
 *
 * ÐÑÐ»Ð¾ `toLocaleDateString().split('.').reverse().join('-')` â ÑÐ°ÑÑÑÑ Ð½Ð°
 * ÑÑÑÑÐºÐ¸Ð¹ ÑÐ¾ÑÐ¼Ð°Ñ `30.10.2025`. ÐÐ° Ð°Ð½Ð³Ð»Ð¾ÑÐ·ÑÑÐ½Ð¾Ð¼ Ð±ÑÐ°ÑÐ·ÐµÑÐµ `toLocaleDateString`
 * Ð¾ÑÐ´Ð°ÑÑ `10/30/2025`, ÑÐ¾ÑÐµÐº Ð½ÐµÑ, split Ð½Ð¸ÑÐµÐ³Ð¾ Ð½Ðµ Ð´ÐµÐ»Ð°ÐµÑ, Ð¸ Ð½Ð° ÑÐµÑÐ²ÐµÑ ÑÑÐ¾Ð´Ð¸Ð»Ð°
 * ÑÑÑÐ¾ÐºÐ° Ð² ÑÑÐ¶Ð¾Ð¼ ÑÐ¾ÑÐ¼Ð°ÑÐµ. Ð Ð°Ð·Ð¾Ð±ÑÐ°Ð»Ð°ÑÑ Ð¾Ð½Ð° ÑÐ°Ð¼ ÑÐ¾Ð»ÑÐºÐ¾ Ð¿Ð¾ Ð²ÐµÐ·ÐµÐ½Ð¸Ñ ÐºÑÐ»ÑÑÑÑÑ.
 *
 * ÐÑÑÑÐ¾Ðµ Ð¸Ð»Ð¸ Ð±Ð¸ÑÐ¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ â ÑÐµÐ³Ð¾Ð´Ð½ÑÑÐ½Ð¸Ð¹ Ð´ÐµÐ½Ñ Ñ Ð´Ð¸Ð»ÐµÑÐ°, Ð° Ð½Ðµ Ñ Ð±ÑÐ°ÑÐ·ÐµÑÐ°.
 */
export const dayString = (value) => {
  // dayjs(undefined) â ÑÑÐ¾ Â«ÑÐµÐ¹ÑÐ°ÑÂ», Ð¸ ÑÐ°ÐºÐ¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ ÑÑÐ¸ÑÐ°ÐµÑÑÑ Ð²Ð°Ð»Ð¸Ð´Ð½ÑÐ¼. ÐÐ·-Ð·Ð°
  // ÑÑÐ¾Ð³Ð¾ Ð¿ÑÑÑÐ°Ñ Ð´Ð°ÑÐ° ÑÑÐ¾Ð´Ð¸Ð»Ð° Ð¿Ð¾ Ð¿ÐµÑÐ²Ð¾Ð¹ Ð²ÐµÑÐºÐµ Ð¸ Ð´Ð°Ð²Ð°Ð»Ð° Ð´ÐµÐ½Ñ Ð±ÑÐ°ÑÐ·ÐµÑÐ°, ÑÐ¾ÑÑ Ð¿Ð¾
  // Ð·Ð°Ð´ÑÐ¼ÐºÐµ Ð¿ÑÑÑÐ¾Ðµ Ð¸ Ð±Ð¸ÑÐ¾Ðµ Ð·Ð½Ð°ÑÐµÐ½Ð¸Ðµ Ð¾Ð´Ð¸Ð½Ð°ÐºÐ¾Ð²Ð¾ Ð¾Ð·Ð½Ð°ÑÐ°ÑÑ ÑÐµÐ³Ð¾Ð´Ð½Ñ Ñ Ð´Ð¸Ð»ÐµÑÐ°.
  // Ð Ð°ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ Ð²Ð¸Ð´Ð½Ð¾ ÑÐ¾Ð»ÑÐºÐ¾ Ð·Ð°Ð¿Ð°Ð´Ð½ÐµÐµ ÐÐ»Ð¼Ð°ÑÑ: Ð½Ð° UTC-Ð¼Ð°ÑÐ¸Ð½Ðµ Ñ 19:00 Ð´Ð¾ Ð¿Ð¾Ð»ÑÐ½Ð¾ÑÐ¸
  // Ð´ÐµÐ½Ñ Ð±ÑÐ°ÑÐ·ÐµÑÐ° Ð¸ Ð´ÐµÐ½Ñ Ð´Ð¸Ð»ÐµÑÐ° ÑÐ°Ð·Ð½ÑÐµ â Ð½Ð° ÑÑÐ¾Ð¼ Ð¸ Ð¿Ð°Ð´Ð°Ð» ÑÐµÑÑ Ð² CI.
  const parsed = value == null ? null : dayjs(value);
  return (parsed?.isValid() ? parsed : fixDateTimezone(new Date())).format('YYYY-MM-DD');
};
